import React from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import Text from 'components/Text';
import TeaserPhoto from 'components/TeaserPhoto';
import { formatPrice } from 'utils/format';
import { Skeleton } from '@mui/material';
import CartButton from './CartButton';
import './index.sass';

const { block, el } = bem('shop-item-teaser');

const ShopItemTeaser = ({ item }) => {
    const { id, name, price, url, isDigital, soonActive, amount } = item.data;
    const { photo } = item;
    const itemURL = isDigital ? `/courses/${ url }` : `/goods/${ url }`;
    return (
        <Link className={ block() } to={ itemURL }>
            <div className={ el('top-block') }>
                <div className={ el('photo') }>
                    <TeaserPhoto src={ photo }/>
                </div>
                <div className={ el('title') }>
                    <Text>{ name }</Text>
                </div>
            </div>
            <div className={ el('price-block') }>
                <Text>{ formatPrice(price) }</Text>
                { !isDigital && <CartButton id={ id } soonActive={ soonActive } maxAmount={ amount }/> }
            </div>
        </Link>
    )
};

export const ShopItemTeaserSkeleton = () => {
    return (
        <div className={ block() }>
            <div className={ el('top-block') }>
                <div className={ el('photo') }>
                    <Skeleton variant='rounded' width={ '100%' }
                              style={ { paddingTop: '100%', borderRadius: '10px' } }/>
                </div>
                <div className={ el('title') }>
                    <Text><Skeleton/></Text>
                </div>
            </div>
            <div className={ el('price-block') }>
                <Skeleton width={ '100%' }/>
            </div>
        </div>
    )
}

export default ShopItemTeaser;


